import * as Yup from "yup";

export interface IVehicleSaleModel {
  id: string;
  saleDate: string | null;
  notForRent: boolean;
  targetPrice: number | null;
  currency: string;
  vatRate: number | null;
  carDefinitionId: string; // AsyncSelectInput için ID
  brand: string;
  model: string;
  fuelType: string;
  vehicleType: string;
  color: string;
  transmission: string;
  initialKm: number | null;
  saleKm: number | null;

  // Eklenen form alanları (DTO'da olmayan ancak formda gerekli olanlar)
  salesChannel: string;
  auctionCompany: string;
  salesPoint: string;
  salesCampaign: string;
  auctionDate: string | null;
  auctionNumber: number | null;
  cariSearch: string | null;
  cariInfo: string;
  description1: string;
  description2: string;
  status: string;
  salesPrice: number | null;
  transferProcess: string;
  notaryInfo: string;
  journalInfo: string;
}

export const initialVehicleSale: IVehicleSaleModel = {
  id: '',
  saleDate: null,
  notForRent: false,
  targetPrice: null,
  currency: "TL",
  vatRate: null,
  carDefinitionId: "",
  brand: "",
  model: "",
  fuelType: "",
  vehicleType: "",
  color: "",
  transmission: "",
  initialKm: null,
  saleKm: null,

  salesChannel: "",
  auctionCompany: "",
  salesPoint: "",
  salesCampaign: "",
  auctionDate: null,
  auctionNumber: null,
  cariSearch: "",
  cariInfo: "",
  description1: "",
  description2: "",
  status: "Ilanda",
  salesPrice: null,
  transferProcess: "Yapılmadı",
  notaryInfo: "",
  journalInfo: "",
};

export const validationVehicleSale = Yup.object().shape({
  saleDate: Yup.date().nullable().required("Satış tarihi zorunludur"),
  targetPrice: Yup.number()
    .nullable()
    .positive("Hedef fiyat pozitif olmalıdır")
    .required("Hedef fiyat zorunludur"),
  currency: Yup.string().required("Para birimi zorunludur"),
  vatRate: Yup.number()
    .nullable()
    .min(0, "KDV oranı 0'dan küçük olamaz")
    .max(100, "KDV oranı 100'den büyük olamaz")
    .required("KDV oranı zorunludur"),
  carDefinitionId: Yup.string().required("Araç seçimi zorunludur"),
  brand: Yup.string().required("Marka zorunludur"),
  model: Yup.string().required("Model zorunludur"),
  fuelType: Yup.string().required("Yakıt tipi zorunludur"),
  vehicleType: Yup.string().required("Araç tipi zorunludur"),
  color: Yup.string().required("Renk zorunludur"),
  transmission: Yup.string().required("Vites tipi zorunludur"),
  initialKm: Yup.number()
    .nullable()
    .min(0, "İlk kilometre negatif olamaz")
    .required("İlk kilometre zorunludur"),
  saleKm: Yup.number()
    .nullable()
    .min(0, "Satış kilometresi negatif olamaz")
    .required("Satış kilometresi zorunludur")
    .moreThan(Yup.ref('initialKm'), 'Satış KM, ilk KM den büyük olmalıdır'),
  salesChannel: Yup.string().required("Satış kanalı zorunludur"),
  salesPoint: Yup.string().required("Satış noktası zorunludur"),
  salesPrice: Yup.number()
    .nullable()
    .positive("Satış fiyatı pozitif olmalıdır")
    .required("Satış fiyatı zorunludur"),
});

// SelectInput için seçenek listeleri
export const CURRENCY_OPTIONS = [
  { value: 'TL', label: 'TL' },
  { value: 'USD', label: 'USD' },
  { value: 'EUR', label: 'EUR' },
];

export const SALES_CHANNEL_OPTIONS = [
  { value: 'WEB', label: 'Web Satış' },
  { value: 'BAYI', label: 'Bayi Satış' },
  { value: 'OFIS', label: 'Ofis Satış' },
];

export const AUCTION_COMPANY_OPTIONS = [
  { value: 'TENDER', label: 'Tender' },
  { value: 'TMO', label: 'TMO' },
];

export const SALES_POINT_OPTIONS = [
  { value: 'ISTANBUL', label: 'İstanbul' },
  { value: 'ANKARA', label: 'Ankara' },
];

export const SALES_CAMPAIGN_OPTIONS = [
  { value: 'KASIM', label: 'Kasım İndirimleri' },
  { value: 'YILSONU', label: 'Yıl Sonu Fırsatları' },
];

export const TRANSFER_PROCESS_OPTIONS = [
  { value: 'YAPILMADI', label: 'Yapılmadı' },
  { value: 'YAPILDI', label: 'Yapıldı' },
];

export const STATUS_OPTIONS = [
  { value: 'ILANDA', label: 'İlanda' },
  { value: 'SATILDI', label: 'Satıldı' },
  { value: 'IPTAL', label: 'İptal' },
];

export const TRANSFER_VALLIDATION = [
    {value: 'Hepsi', label: 'Hepsi'},
    {value: 'Satışta Olanlar' , label: 'Satışta Olanlar'},
    {value: 'Dönenler' ,label: 'Dönenler'}
]

export const DATE_FILTER_OPTIONS = [
     {value: 'Hepsi', label: 'Hepsi'},
    {value: 'Geçmiş Satış' , label: 'Geçmiş Satış'},
    {value: 'Planlanan Satış' ,label: 'Planlanan Satış'}
]